import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23.4168 8.66139L19.3693 3.26471H5.88973L1.83008 8.66139M23.4168 8.66139L12.6234 22.1531M23.4168 8.66139H1.83008M12.6234 22.1531L1.83008 8.66139M12.6234 22.1531L8.57593 8.66139M12.6234 22.1531L16.6709 8.66139",
      stroke: "#0E1422",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.88867 3.26471L8.57487 8.66139L12.6224 3.26471L16.6699 8.66139L19.3682 3.26471",
      stroke: "#0E1422",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }